module.exports = __webpack_public_path__ + "media/brands/kirchhoff-89431fe5.png";